module.exports = __webpack_public_path__ + "img/slider-banner-3.d360eaef.jpg";